import * as React from 'react';
import { getHostLocation } from 'owa-url/lib/hostLocation';
import { getTodoModuleUrl } from 'owa-url';
import { getUserConfiguration } from 'owa-session-store';
import { isFeatureEnabled } from 'owa-feature-flags';
import { logUsage } from 'owa-analytics';
import { Module } from '../utils/Module';
import { shouldUseTodoModule } from './shouldUseTodoModule';
import { tryReuseOpenedTab } from 'owa-tab-reuse';
import {
    getMailPath,
    getCalendarPath,
    getPeoplePath,
    getFilesHubPath,
    getOutlookSpacesPath,
    getOwaUrlWithAddedQueryParameters,
} from 'owa-url';

export function onClickHandler(
    workload: Module,
    selectedModule: Module,
    activeModuleAction?: (
        ev?: React.MouseEvent<unknown> | React.KeyboardEvent<HTMLElement>
    ) => void,
    isOverflowItem?: boolean
) {
    // If clicked workload is the selected module and there is an action given for it (ex: mail is to select default folder),
    // then call that action.
    if (workload === selectedModule && activeModuleAction) {
        activeModuleAction();
    } else if (tryReuseOpenedTab(Module[workload].toLowerCase())) {
        window.open(getModuleSwitcherItemURL(workload).toString(), '_blank');
    }

    if (workload === Module.Tasks) {
        const userConfiguration = getUserConfiguration();
        const isExplicitLogon = userConfiguration?.SessionSettings?.IsExplicitLogon;

        /**
         * This datapoint tracks clicks on the To Do module in the switcher, and whether
         * or not the user is using explicit logon or not. This datapoint is temporary
         * to collect data so the To Do team can make a decision regarding whether
         * or not to support this type of scenario.
         *
         * Work Item 59464: Remove ModuleSwitch_ToDo datapoint
         */
        logUsage('ModuleSwitch_ToDo', [isExplicitLogon]);
    }

    logUsage('ModuleSwitch', [selectedModule.toString(), workload.toString()], {
        isCore: true,
    });
}

export function getModuleSwitcherItemURL(workload: Module): string {
    const userOptions = getUserConfiguration().UserOptions;

    switch (workload) {
        case Module.Mail:
            return getMailPath() + getHostLocation().search;
        case Module.Calendar:
            return isFeatureEnabled('cal-react') || userOptions?.ReactOptinSettings?.CalendarEnabled
                ? getCalendarPath() + getHostLocation().search
                : getOwaUrlWithAddedQueryParameters({ path: '/calendar' });
        case Module.People:
            return isFeatureEnabled('fwk-peopleReact') ||
                userOptions?.ReactOptinSettings?.PeopleEnabled
                ? getPeoplePath() + getHostLocation().search
                : getOwaUrlWithAddedQueryParameters({ path: '/people' });
        case Module.FilesHub:
            return getFilesHubPath() + getHostLocation().search;
        case Module.Tasks:
            return shouldUseTodoModule()
                ? getTodoModuleUrl()
                : getOwaUrlWithAddedQueryParameters({ path: '/tasks' });
        case Module.OutlookSpaces:
            return getOutlookSpacesPath() + getHostLocation().search;
        default:
            throw new Error("Cannot get module switcher item URL of a workload that doesn't exist");
    }
}
